import React, { useCallback, useEffect, useState } from 'react';
import { FlexWrapper, HighlightText, PaginationBox, ViewIconBox } from '../../theme/common_style';
import { Badge, Button, Pagination, Segmented, Table } from 'antd';
import { FilterIconNew, NoLeaveIcon, Plusicon, ViewIconNew } from '../../theme/SvgIcons';
import SearchField from '../../components/searchField/SearchField';
import { useNavigate } from 'react-router-dom';
import AddLeave from './AddLeave';
import EmptyData from '../../components/common/EmptyData';
import EmployeeCard from './EmployeeCard';
import { useDispatch, useSelector } from 'react-redux';
import { GetEmployeeLeavesApi, GetLeavesListingApi } from '../../redux/lms/apiRoute';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import {
  checkPermission,
  convertToLocalDate,
  convertToLocalTime,
  debounce,
  generateEmployeeImgUrl,
  getCategory,
  getFullName,
  getSlot,
  getStatusTag,
  useWindowWide
} from '../../utils/common_functions';
import { StickyBox } from '../../utils/style';
import colors from '../../theme/colors';
import { actionTypeEnums, apiModules, LeaveTabOptions } from '../../utils/constant';
import { updateLmsTab } from '../../redux/lms/LmsSlice';
import { useTheme } from '@emotion/react';
import { AvatarGroup } from '../../components/common/AvatarGroup';
import styled from '@emotion/styled';

const LmsDetails = ({ updateGraph, setFilterDrawer, appliedFilter, page, setPage, limit }) => {
  const [total, setTotal] = useState(10);
  const [loading, setLoading] = useState(true);
  const [apiData, setApiData] = useState();
  const activeTab = useSelector((state) => state?.LmsSlice?.LmsTab);
  const [addModal, setAddModal] = useState(false);
  const [search, setSearch] = useState('');
  const largeScreen = useWindowWide(1085);
  const mediumScreen = useWindowWide(600);
  const anotherlargeScreen = useWindowWide(820);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isEmployee, data } = useSelector((e) => e.userInfo);
  const { permissions } = useSelector((state) => state?.userInfo?.data);
  const { READ, CREATE } = actionTypeEnums;
  const { EMPLOYEE, LEAVE_MANAGEMENT_SUSTEM } = apiModules;
  const [sort, setSort] = useState({});
  const canCreate = checkPermission(LEAVE_MANAGEMENT_SUSTEM, CREATE, permissions);
  const [editData, setEditData] = useState(null);
  const theme = useTheme();

  const canReadEmp = checkPermission(EMPLOYEE, READ, permissions);

  const handleEdit = (item) => {
    setAddModal(true);
    setEditData(item);
  };

  const fetchData = (search) => {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);
    params.append('filter', activeTab);
    params.append('moduleType', apiModules.LEAVE_MANAGEMENT_SUSTEM);
    sort?.sortBy && params.append('sort_by', sort?.sortBy);
    sort?.orderBy && params.append('sort_order', sort?.orderBy);
    search && params.append('search', search);
    if (Object.keys(appliedFilter || {}).length > 0) {
      Object.entries(appliedFilter).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, value);
        }
      });
    }
    const id = data?.user_details?.id;
    if (!isEmployee) {
      getLmsAdmin(params);
    } else {
      getLmsEmployee(params, id);
    }
  };

  const getLmsEmployee = async (payload, id) => {
    setLoading(true);
    try {
      const res = await GetEmployeeLeavesApi(payload, id);
      if (res?.statusCode == 200) {
        setApiData(res?.data?.leaves);
        setTotal(res?.data?.total);
      } else toast.error(res?.message || 'Something went wrong');
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const getLmsAdmin = async (payload) => {
    setLoading(true);
    try {
      const res = await GetLeavesListingApi(payload);
      if (res?.statusCode === 200) {
        setApiData(res?.data?.leaves);
        setTotal(res?.data?.totalLeaves);
      } else toast.error(res?.message || 'Something went wrong');
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSorting = (val) => {
    if (val?.field) {
      let order = val?.order == 'ascend' ? 'ASC' : 'DESC';
      setSort({ sortBy: val?.columnKey, orderBy: order, ...val });
    }
    setPage(page);
  };

  const columns = [
    {
      width: 180,
      title: 'Emp Name',
      dataIndex: 'employee',
      key: 'employee_name',
      sorter: true,
      render: (employee) => {
        const emp = [
          {
            name: getFullName(employee?.first_name, employee?.middle_name, employee?.last_name),
            src: generateEmployeeImgUrl(employee?.id),
            id: employee?.id
          }
        ];
        return (
          <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
            <AvatarGroup avatars={emp} />
            {!isEmployee && canReadEmp ? (
              <HighlightText
                onClick={() =>
                  navigate(`/view-employee`, {
                    state: {
                      id: employee?.id,
                      name: emp[0]?.name
                    }
                  })
                }>
                {employee?.first_name}
              </HighlightText>
            ) : (
              <span>{employee?.first_name}</span>
            )}
          </FlexWrapper>
        );
      }
    },
    {
      width: 120,
      title: 'Emp Code',
      sorter: true,
      dataIndex: 'emp_code',
      key: 'emp_code',
      render: (_, record) => {
        return (
          <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
            <span>{record?.employee?.emp_code}</span>
          </FlexWrapper>
        );
      }
    },
    {
      width: 120,
      title: 'Leave Type',
      dataIndex: 'leave_type',
      key: 'leave_type',
      render: (leave_type) => {
        return (
          <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
            <span>{leave_type}</span>
          </FlexWrapper>
        );
      }
    },
    {
      width: 130,
      title: 'Applied On',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (created_at) => {
        return (
          <FlexWrapper style={{ textAlign: 'center' }}>
            {convertToLocalTime(created_at)}
          </FlexWrapper>
        );
      }
    },
    {
      width: 130,
      title: 'Start Date',
      dataIndex: 'start_date',
      key: 'start_date',
      sorter: true,
      render: (startDate) => {
        return (
          <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
            {convertToLocalDate(startDate)}
          </FlexWrapper>
        );
      }
    },
    {
      width: 130,
      title: 'End Date',
      dataIndex: 'end_date',
      key: 'end_date',
      sorter: true,
      render: (endDate) => {
        return (
          <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
            {convertToLocalDate(endDate)}
          </FlexWrapper>
        );
      }
    },
    {
      width: 120,
      title: 'No of Leaves',
      dataIndex: 'no_of_leaves',
      key: 'no_of_leaves',
      render: (no_of_leaves) => (
        <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
          <span>{no_of_leaves || 'N/A'}</span>
        </FlexWrapper>
      )
    },
    {
      width: 140,
      title: 'Leave Category',
      dataIndex: 'leave_category',
      key: 'leave_category',
      render: (leave_category) => getCategory(leave_category) ?? 'N/A'
    },
    {
      width: 120,
      title: 'Leave Slot',
      dataIndex: 'leave_slot',
      key: 'leave_slot',
      render: (leave_slot) => getSlot(leave_slot) ?? 'N/A'
    },
    {
      width: 110,
      title: 'Status',
      dataIndex: 'leave_status',
      key: 'leave_status',
      fixed: 'right',
      render: (status) => getStatusTag(status)
    },
    {
      width: 70,
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      fixed: 'right',
      className: 'action-column',
      render: (_, data) => {
        return (
          <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'}>
            <ViewIconBox
              onClick={() => {
                navigate(`/lms/details`, {
                  state: { lms: data }
                });
              }}>
              <ViewIconNew />
            </ViewIconBox>
          </FlexWrapper>
        );
      }
    }
  ];

  const optimizedFn = useCallback(debounce(fetchData), [
    data,
    activeTab,
    page,
    appliedFilter,
    sort
  ]);

  useEffect(() => {
    if (search !== null) {
      optimizedFn(search);
    } else {
      fetchData();
    }
  }, [data, search, activeTab, page, appliedFilter, sort]);

  return (
    <div style={{ marginTop: '20px' }}>
      {addModal && (
        <AddLeave
          open={addModal}
          onClose={() => {
            setAddModal(false);
            setEditData(null);
          }}
          fetchData={fetchData}
          updateGraph={updateGraph}
          editData={editData}
        />
      )}
      <StickyBox padding="8px 0">
        <FlexWrapper
          width={'100%'}
          justify={largeScreen ? 'space-between' : 'start'}
          align={'center'}
          gap="16px"
          cursor="default"
          style={{
            marginBottom: '16px'
          }}>
          <FlexWrapper
            justify={'start'}
            width={mediumScreen ? 'fit-content' : '100%'}
            align="start">
            <Segmented
              value={activeTab}
              prefixCls="antCustomSegmented"
              options={LeaveTabOptions}
              onChange={(value) => {
                dispatch(updateLmsTab(value));
                setPage(1);
              }}
              className="responsive-segmented"
            />
          </FlexWrapper>

          <FlexWrapperParent justify={largeScreen ? 'end' : 'start'} gap="6px" cursor="default">
            <SearchField
              width={`250px`}
              placeholder="Search by Leave type..."
              value={search}
              onChange={(val) => {
                setSearch(val);
                setPage(1);
              }}
              allowClear={true}
            />
            <BoxButton>
              <Badge
                count={Object?.values(appliedFilter || {})?.reduce(
                  (acc, item) => acc + (item ? 1 : 0),
                  0
                )}
                color={theme?.primaryColor}
                offset={[-9, 4]}
                prefixCls="filterBadge">
                <Button prefixCls="custom-filter-btn" onClick={() => setFilterDrawer(true)}>
                  <FilterIconNew /> {'Filter'}
                </Button>
              </Badge>
              {canCreate && isEmployee && (
                <Button
                  type="text"
                  onClick={() => setAddModal(true)}
                  prefixCls="antCustomBtn"
                  style={{
                    width: anotherlargeScreen ? '164px' : '100%'
                  }}>
                  <Plusicon fill={colors.white} w="15" h="15" />
                  {'Add Leave'}
                </Button>
              )}
            </BoxButton>
          </FlexWrapperParent>
        </FlexWrapper>
      </StickyBox>
      {!isEmployee ? (
        loading || apiData?.length > 0 ? (
          <div style={{ width: '100%' }}>
            <Table
              prefixCls="antCustomTable"
              scroll={{ x: '100%' }}
              columns={columns}
              dataSource={apiData}
              pagination={false}
              loading={loading}
              onChange={(newPagination, filters, sorter) => {
                if (!sorter.order) {
                  setSort({});
                } else {
                  handleSorting(sorter);
                }
              }}
              defaultSortOrder={sort.order}
            />
            {total > limit && (
              <PaginationBox>
                <Pagination
                  current={page}
                  prefixCls="custom-pagination"
                  pageSize={limit}
                  total={total}
                  onChange={(e) => setPage(e)}
                  showSizeChanger={false}
                />
              </PaginationBox>
            )}
          </div>
        ) : (
          <EmptyData
            height={'50vh'}
            icon={<NoLeaveIcon />}
            title={'No Leave'}
            subTitle={`There are no leave requested.`}
          />
        )
      ) : loading || apiData?.length > 0 ? (
        <div style={{ width: '100%' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {apiData?.map((item, index) => (
              <EmployeeCard item={item} key={index} loading={loading} handleEdit={handleEdit} />
            ))}
          </div>
          {total > limit && (
            <PaginationBox>
              <Pagination
                current={page}
                prefixCls="custom-pagination"
                pageSize={limit}
                total={total}
                onChange={(e) => setPage(e)}
                showSizeChanger={false}
              />
            </PaginationBox>
          )}
        </div>
      ) : (
        <EmptyData
          height={'50vh'}
          icon={<NoLeaveIcon />}
          title={'No Leave'}
          subTitle={`There are no leave requested.`}
        />
      )}
    </div>
  );
};

export default LmsDetails;

LmsDetails.propTypes = {
  updateGraph: PropTypes.func.isRequired,
  setFilterDrawer: PropTypes.func.isRequired,
  appliedFilter: PropTypes.object,
  setPage: PropTypes.func,
  page: PropTypes.number,
  limit: PropTypes.number
};
const FlexWrapperParent = styled.div`
  width: ${(props) => props.width};
  display: flex;
  flex-wrap: ${(props) => props.wrap || 'nowrap'};
  flex-direction: ${(props) => props.direction || 'row'};
  justify-content: ${(props) => props.justify || 'center'};
  align-items: ${(props) => props.align || 'center'};
  gap: ${(props) => props.gap || '10px'};
  cursor: ${(props) => props.cursor || 'auto'};
  margin: ${(props) => props.margin || '0px'};

  @media (max-width: 768px) {
    width: 100%;
    flex-wrap: wrap;
    justify-content: start;
  }

  @media (max-width: 568px) {
    width: 100%;
    align-items: start;
    justify-content: start;
    flex-direction: column-reverse;
  }
`;

const BoxButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  @media (max-width: 668px) {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
`;
